import AppService from "./app-service"

export default class ExamTypeService extends AppService {

  constructor() {
    super({ path: "exam-types" })
  }
}